export const muteOrUnmuteVoiceValues = ['unmute_voice', 'mute_voice']

export const alarmPanicDuressValues = { panic: 2, duress: 3 }

export const alarmPanicDuressNumbers = { 2: 'panic', 3: 'duress' }
